import React, { useEffect, useContext, useState } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
// @material-ui/icons
import Store from "@material-ui/icons/Store";
import DateRange from "@material-ui/icons/DateRange";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Tasks from "components/Tasks/Tasks.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Skeleton from "@material-ui/lab/Skeleton";
import axios from "axios";
import moment from "moment";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highchartsMore from "highcharts/highcharts-more.js";
import solidGauge from "highcharts/modules/solid-gauge.js";

import { bugs, website, server } from "variables/general.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);
highchartsMore(Highcharts);
solidGauge(Highcharts);

export default function Dashboard() {
  const classes = useStyles();
  const [loader, setLoader] = useState(true);
  let id_empresa = localStorage.getItem("id_empresa");
  const [values, setValues] = useState({
    nombreEmpresa: "",
    descripcionEmpresa: "",
    ultima_conexion: "",
    error: false,
  });

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  useEffect(() => {
    const data = async () => {
      axios
        .get(`${urlServices}company/companycontatos/` + id_empresa, {
          headers: {
            application: keyAplication,
          },
        })
        .then(
          (response) => {
            if (response.data !== "") {
              setValues({
                ...values,
                nombreEmpresa: response.data.nombre,
                descripcionEmpresa: response.data.descripcion,
                ultima_conexion: response.data.ultima_conexion,
              });

              setLoader(false);
            } else {
              setValues({ ...values, error: true });
              setLoader(false);
            }
          },
          (error) => {
            console.log(error);
            setValues({ ...values, error: true });
            setLoader(false);
          }
        );
    };

    data();
  }, [urlServices, keyAplication, id_empresa]);

  const options = {
    chart: {
      type: "solidgauge",
      height: 150,
    },
    title: {
      text: null,
    },
    pane: {
      center: ["50%", "85%"],
      size: "140%",
      startAngle: -90,
      endAngle: 90,
      background: {
        backgroundColor: Highcharts.Color(Highcharts.getOptions().colors[0])
          .setOpacity(0.3)
          .get(),
        borderWidth: 0,
        innerRadius: "48%",
        outerRadius: "122%",
        shape: "arc",
      },
    },

    exporting: {
      enabled: false,
    },

    tooltip: {
      enabled: false,
    },

    // the value axis
    yAxis: {
      stops: [
        [0.1, "#DF5353"], // green
        [0.4, "#DDDF0D"], // yellow
        [0.8, "#55BF3B"], // red
      ],
      min: 1,
      max: 100,
      lineWidth: 0,
      tickWidth: 0,
      minorTickInterval: null,
      tickAmount: 2,
      title: {
        y: -70,
      },
      labels: {
        y: 16,
      },
    },

    plotOptions: {
      solidgauge: {
        dataLabels: {
          y: 5,
          borderWidth: 0,
          useHTML: true,
        },
      },
    },
    series: [
      {
        name: "Move",
        type: "solidgauge",
        data: [
          {
            radius: "48%",
            innerRadius: "122%",
            y: 60,
          },
        ],
        dataLabels: {
          format:
            '<div style="text-align:center">' +
            '<span style="font-size:22px;font-weight: 600; color: #333; font-family: "Roboto", "Helvetica", "Arial", sans-serif">{y}</span><br/>' +
            '<span style="font-size:12px;opacity:0.4">%</span>' +
            "</div>",
        },
      },
    ],
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Store />
              </CardIcon>
              <p className={classes.cardCategory}>Bienvenid@</p>
              {loader ? (
                <Skeleton
                  style={{ float: "right" }}
                  variant="text"
                  width="60%"
                />
              ) : (
                <h3 className={classes.cardNameCompany}>
                  {values.nombreEmpresa}
                </h3>
              )}
            </CardHeader>
            <CardBody>
              {loader ? (
                <Box>
                  <Skeleton
                    style={{ float: "right" }}
                    variant="text"
                    width="90%"
                  />
                  <Skeleton
                    style={{ float: "right" }}
                    variant="text"
                    width="60%"
                  />
                </Box>
              ) : (
                <p className={classes.cardCategory}>
                  {values.descripcionEmpresa}
                </p>
              )}
            </CardBody>
            <CardFooter stats>
              {loader ? (
                <Box>
                  <Skeleton
                    style={{ float: "right" }}
                    variant="text"
                    width={200}
                  />
                </Box>
              ) : (
                <Box>
                  <div className={classes.stats}>
                    <DateRange />
                    Ultimo acceso{" "}
                    {moment(values.ultima_conexion).format(
                      "YYYY-MM-DD H:mm:ss"
                    )}
                  </div>
                </Box>
              )}
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card chart>
            <CardHeader>
              <h4 className={classes.cardCategory}>Porcentaje de registro</h4>
              {loader ? (
                <Skeleton
                  style={{ textAling: "center" }}
                  variant="react"
                  width="100%"
                  height={150}
                />
              ) : (
                <Box>
                  {
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={options}
                    />
                  }
                </Box>
              )}
            </CardHeader>
          </Card>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <CustomTabs
            title="Tasks:"
            headerColor="primary"
            tabs={[
              {
                tabName: "Bugs",
                tabIcon: BugReport,
                tabContent: (
                  <Tasks
                    checkedIndexes={[0, 3]}
                    tasksIndexes={[0, 1, 2, 3]}
                    tasks={bugs}
                  />
                ),
              },
              {
                tabName: "Website",
                tabIcon: Code,
                tabContent: (
                  <Tasks
                    checkedIndexes={[0]}
                    tasksIndexes={[0, 1]}
                    tasks={website}
                  />
                ),
              },
              {
                tabName: "Server",
                tabIcon: Cloud,
                tabContent: (
                  <Tasks
                    checkedIndexes={[1]}
                    tasksIndexes={[0, 1, 2]}
                    tasks={server}
                  />
                ),
              },
            ]}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="warning">
              <h4 className={classes.cardTitleWhite}>Employees Stats</h4>
              <p className={classes.cardCategoryWhite}>
                New employees on 15th September, 2016
              </p>
            </CardHeader>
            <CardBody>
              <Table
                tableHeaderColor="warning"
                tableHead={["ID", "Name", "Salary", "Country"]}
                tableData={[
                  ["1", "Dakota Rice", "$36,738", "Niger"],
                  ["2", "Minerva Hooper", "$23,789", "Curaçao"],
                  ["3", "Sage Rodriguez", "$56,142", "Netherlands"],
                  ["4", "Philip Chaney", "$38,735", "Korea, South"],
                ]}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
